export const DEFAULT_MESSAGE = 'An error occurred';
export const DEFAULT_RETRY_TEXT = 'Retry';
export const DEFAULT_SHOW_ICON = true;
